import { nameof } from "../../store/services/metadataService";
import { IValidator } from '../../validation';
import DatePickerInput from '../common/inputs/DatePickerInput';
import { IWithStartFinishDates } from '../../entities/common';
import { IInputProps } from "../common/interfaces/IInputProps";
import * as Metadata from '../../entities/Metadata';
import { ProjectInfo } from "../../store/ProjectsListStore";
import * as Notifications from "../../store/NotificationsStore";

export const rendersBuilder = (notificationsActions: typeof Notifications.actionCreators) => ({
    [nameof<IWithStartFinishDates>("StartDate")]: (props: IInputProps, state: ProjectInfo, field: Metadata.Field, validator?: IValidator): JSX.Element | null =>
        <DatePickerInput {...props}
            inputProps={{
                readOnly: field.isReadonly,
                title: state?.settings?.calculateStartFinishDate
                    ? `${field?.label} is automatically rolled up from the primary schedule`
                    : undefined
            }}
            validator={validator}
            maxDate={state.attributes.FinishDate}
            onEditComplete={(value: string | null) => {
                if (state?.settings?.calculateStartFinishDate) {
                    notificationsActions.pushNotification({
                        message: `Manually entered ${field?.label} will be overwritten with the rolled-up date when the primary schedule is updated.`,
                        type: Notifications.NotificationType.Warn
                    });
                }

                props.onEditComplete(value);
            }}
        />,
    [nameof<IWithStartFinishDates>("FinishDate")]: (props: IInputProps, state: ProjectInfo, field: Metadata.Field, validator?: IValidator): JSX.Element | null =>
        <DatePickerInput {...props}
            inputProps={{
                readOnly: field.isReadonly,
                title: state?.settings?.calculateStartFinishDate
                    ? `${field?.label} is automatically rolled up from the primary schedule`
                    : undefined
            }}
            validator={validator}
            minDate={state.attributes.StartDate}
            onEditComplete={(value: string | null) => {
                if (state?.settings?.calculateStartFinishDate) {
                    notificationsActions.pushNotification({
                        message: `Manually entered ${field?.label} will be overwritten with the rolled-up date when the primary schedule is updated.`,
                        type: Notifications.NotificationType.Warn
                    });
                }

                props.onEditComplete(value);
            }}
        />
})